<template>
  <div class="row q-pt-sm">
    <div class="col-md-6 col-sm-12 col-12">
      <MarketSummary
        :isMarketOn="isMarketOn"
        @clickSectorRow="onClickSectorRow"
        :marketLive="marketLive"
        @emitSector="
          (emitData) => {
            emitSector = emitData;
          }
        "
      />
    </div>
    <div class="col-md-6 col-sm-12 col-12 q-mt-md q-mt-md-none q-pl-md-sm">
      <TopGainers
        v-if="topGainers"
        :isMarketOn="isMarketOn"
        :sectorId="selectedSectorId"
        :allStocks="allStocks"
        :topGainers="topGainers"
        :filterTableSeriesDataForGainers="filterTableSeriesDataForGainers"
      />
      <TopLosers
        class="q-mt-md"
        v-if="topLosers"
        :isMarketOn="isMarketOn"
        :sectorId="selectedSectorId"
        :allStocks="allStocks"
        :topLosers="topLosers"
        :filterTableSeriesDataForLosers="filterTableSeriesDataForLosers"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, watchEffect } from "vue";

import MarketSummary from "src/components/MarketSummary.vue";
import TopLosers from "./TopLosers.vue";
import TopGainers from "./TopGainers.vue";

export default {
  name: "MarketSummaryAfterMarket",
  components: { MarketSummary, TopLosers, TopGainers },

  props: {
    allStocks: { type: Array },
    topGainers: { type: Array },
    topLosers: { type: Array },
    marketLive: { type: Array },
    isMarketOn: { default: false },
  },
  emits: ["emitSector"],
  setup(props, context) {
    const selectedSectorId = ref(null);
    const filterTableSeriesDataForGainers = ref([]);
    const filterTableSeriesDataForLosers = ref([]);
    const filterStockData = ref([]);
    const tableSeriesDataForGainers = ref([]);
    const tableSeriesDataForLosers = ref([]);
    const emitSector = ref({});

    const seriesDataForGainers = () => {
      return props.isMarketOn == true
        ? props.topGainers !== null && props.topGainers
        : [];
    };
    const seriesDataForLosers = () => {
      return props.isMarketOn == true
        ? props.topLosers !== null && props.topLosers
        : [];
    };

    const filterStockPerformanceDataBySector = () => {
      filterStockData.value = props.allStocks.filter((item) => {
        if (!selectedSectorId.value) return true;
        return item.sector == selectedSectorId.value;
      });
      tableSeriesDataForGainers.value = seriesDataForGainers();

      filterTableSeriesDataForGainers.value =
        tableSeriesDataForGainers.value.filter((i1) =>
          filterStockData.value.some((i2) => i1.symbol === i2.symbol)
        );

      tableSeriesDataForLosers.value = seriesDataForLosers();
      filterTableSeriesDataForLosers.value =
        tableSeriesDataForLosers.value.filter((i1) =>
          filterStockData.value.some((i2) => i1.symbol === i2.symbol)
        );
    };
    watch(props, (newVal, oldVal) => {
      filterStockPerformanceDataBySector();
    });
    const onClickSectorRow = (emittedSector) => {
      selectedSectorId.value = emittedSector.sectorId;
      filterStockPerformanceDataBySector();
    };

    watchEffect(() => {
      const newVal = emitSector.value;
      context.emit("emitSector", newVal);
    });

    return {
      selectedSectorId,
      onClickSectorRow,
      filterTableSeriesDataForGainers,
      filterTableSeriesDataForLosers,
      filterStockData,
      tableSeriesDataForGainers,
      tableSeriesDataForLosers,
      seriesDataForGainers,
      seriesDataForLosers,
      emitSector,
    };
  },
};
</script>
